// extracted by mini-css-extract-plugin
export default {"titleBuy":"titleBuy__Vxmwq","titleAvoid":"titleAvoid__dDe9N","xt150":"xt150__qvLkE","xt60":"xt60__L26rR"};